import {
  Component, ChangeDetectionStrategy, HostBinding,
} from '@angular/core'

@Component({
  selector: 'kb-line-clamp,[kb-line-clamp]',
  templateUrl: './line-clamp.component.html',
  styleUrls: ['./line-clamp.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class LineClampComponent {
  @HostBinding('attr.tabindex') private tabindex = 0 // needed to enable focus style
}
